export enum BrandEnum {
  Unknown,
  TcbPersonal,
  BaskBank,
  TcbPrivate
}
